import React from 'react';
import FieldFormGrid from './Grid';

const FieldTests = ({customFilter}) => {
  return (
    <FieldFormGrid customFilter={customFilter} />
  )
}

export default FieldTests;